import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function PostMainImage({ post }) {
  return (
    <>
      { 
        post ? (
          <>
            <figure className="pickup-article-pc">
              <GatsbyImage image={getImage(post.thumbnailLandscape.src)} alt={post.title} />
            </figure>
            <figure className="pickup-article-sp">
              <GatsbyImage image={getImage(post.thumbnailSquare.src)} alt={post.title} />
            </figure>
          </>
        ) : ''
      }
    </>
  )
}
